export const handleUrlDownload = (url, fileName) => {
  const link = document.createElement('a');
  link.href = url;
  link.target = '_blank';
  if (fileName) {
    link.setAttribute('download', fileName);
  }
  link.click();
  link.remove();
};

// The zip a policy download hands back, named for the purpose it was generated under so the three
// flows do not all land in the downloads folder as SecurityCatalogs.
export const policyArtifactZipName = (policyPurpose, version) =>
  `${policyPurpose}_${version || 'latest'}.zip`;

const handleBlobDownload = (response, fileName, type) => {
  const blob = new Blob([response], { type });
  const url = window.URL.createObjectURL(blob);
  handleUrlDownload(url, fileName);
  window.URL.revokeObjectURL(url);
};

export const handleZipFileDownload = (response, fileName) =>
  handleBlobDownload(response, fileName, 'application/zip');

export const handleFileDownload = (response, fileName) =>
  handleBlobDownload(response, fileName, 'application/octet-stream');

export const handleCsvFileDownload = (response, fileName) =>
  handleBlobDownload(response, fileName, 'text/csv');

// The name an export lands under, stamped to the second in UTC like the server-side exports.
export const csvExportFileName = prefix =>
  `${prefix}_${new Date()
    .toISOString()
    .slice(0, 19)
    .replace(/[-:]/g, '')
    .replace('T', '_')}.csv`;
